// useFetchAgencies.js
import { useState, useEffect } from 'react';

import { useGetAgenciesQuery } from '../redux/modules/application';

export function useFetchAgencies(token, searchBy, listRef) {

    const [agencies, setAgencies] = useState([]);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(true);

    const { refetch, data } = useGetAgenciesQuery({
        token,
        limit: 25,
        offset: page * 25,
        searchBy: searchBy || ''
    });

    useEffect(() => {
        if (data) {
            if(data.length < 25) setHasMore(false);

            const mappedAgencies = data.map(item => ({ label: item.name, value: item.companyId }));
            if(page === 0) setAgencies(mappedAgencies);
            else setAgencies((prev) => [...prev, ...mappedAgencies]);
        }
    }, [data]);

    const handleScroll = () => {
        const { scrollTop, clientHeight, scrollHeight } = listRef.current;
        if (scrollHeight - scrollTop === clientHeight && hasMore) {
            setPage((prev) => prev + 1);
        }
    };

    useEffect(() => {
        refetch();
    }, [page]);

    return { 
        refetchAgencies: refetch, agencies, handleScroll, hasMore, setPage, setHasMore 
    };
}
